import { AxiosResponse } from "axios";
import type { InferType } from "yup";
import * as yup from "yup";

import api from "../utils/AxiosInterceptor";
import i18n from "../i18n";

export const resendEmailVerificationSchemaInput = yup.object({
  document: yup.string().required(() => i18n.t("validation.cpfRequiredShort")).validateCpf(),
});

export type ResendEmailVerificationInput = InferType<
  typeof resendEmailVerificationSchemaInput
>;

export async function resendEmailVerification(
  input: ResendEmailVerificationInput,
): Promise<AxiosResponse<void>> {
  return await api.get(`/api/v1/auth/resend-verify-email/${input.document}`);
}
